'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _productGallerySlide = require('./productGallerySlide');

var _productGallerySlide2 = _interopRequireDefault(_productGallerySlide);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Sliders = function () {
  function Sliders() {
    (0, _classCallCheck3.default)(this, Sliders);

    // Gallery
    this.galleryWrapper = '.js-gallery-wrapper';
    this.gallery = '.js-pdp-gallery';
    this.galleryList = '.slick-list';
    this.galleryNav = '.js-gallery-navigation';
    this.galleryPrev = '.js-pdp-gallery-prev';
    this.galleryNext = '.js-pdp-gallery-next';

    // Lifestyle
    this.lifestyle = '.js-lifestyle-gallery';
    this.lifestyleNav = '.js-lifestyle-navigation';
    this.lifestylePrev = '.js-pdp-lifestyle-prev';
    this.lifestyleNext = '.js-pdp-lifestyle-next';

    this.createGallerySlick();
    this.createLifestyleSlick();
  }

  (0, _createClass3.default)(Sliders, [{
    key: 'createGallerySlick',
    value: function createGallerySlick() {
      var _this = this;

      var gallery = this.gallery;

      var options = {
        appendArrows: (0, _jquery2.default)(this.galleryNav),
        arrows: true,
        centerMode: true,
        centerPadding: '300px',
        draggable: true,
        infinite: true,
        prevArrow: (0, _jquery2.default)(this.galleryPrev),
        nextArrow: (0, _jquery2.default)(this.galleryNext),
        responsive: [{
          breakpoint: 974,
          settings: {
            centerMode: false,
            centerPadding: '0px'
          }
        }],
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true
      };

      (0, _jquery2.default)(gallery).slick(options);

      var elementExists = window.setInterval(function () {
        var isSet = _this.setSliderHeight();
        if (isSet) {
          window.clearInterval(elementExists);
        }
      }, 100);
    }
  }, {
    key: 'setSliderHeight',
    value: function setSliderHeight() {
      var gallery = this.gallery,
          galleryList = this.galleryList;

      var galleryElement = document.querySelector(gallery);
      var galleryListElement = galleryElement.querySelector(galleryList);
      var galleryHeight = galleryElement.offsetHeight;
      if (galleryListElement) {
        galleryListElement.style.height = galleryHeight + 'px';
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'destroySlick',
    value: function destroySlick() {
      var gallery = document.querySelector(this.gallery);
      var galleryHeight = gallery.offsetHeight;

      function removeSlides() {
        var index = 0;
        var slideCount = gallery.querySelectorAll('.slick-slide').length;

        // maintain height of slider while removing all slides
        gallery.style.height = galleryHeight + 'px';

        // remove slides
        do {
          (0, _jquery2.default)(gallery).slick('slickRemove', true);
          index += 1;
        } while (index < slideCount);
      }

      removeSlides();
    }
  }, {
    key: 'rebuildSlick',
    value: function rebuildSlick(images) {
      var self = this;
      var gallery = document.querySelector(this.gallery);

      self.toggleLoader();

      setTimeout(function () {
        self.destroySlick();

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = images[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var image = _step.value;

            var imgHtml = _productGallerySlide2.default.html(image.alt, image.url);
            (0, _jquery2.default)(gallery).slick('slickAdd', imgHtml);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        gallery.style.height = 'auto';

        setTimeout(function () {
          self.toggleLoader();
        }, 300);
      }, 300);
    }
  }, {
    key: 'createLifestyleSlick',
    value: function createLifestyleSlick() {
      var lifestyle = this.lifestyle;

      var options = {
        appendArrows: (0, _jquery2.default)(this.lifestyleNav),
        arrows: true,
        draggable: true,
        infinite: true,
        prevArrow: (0, _jquery2.default)(this.lifestylePrev),
        nextArrow: (0, _jquery2.default)(this.lifestyleNext),
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true
      };

      (0, _jquery2.default)(lifestyle).slick(options);
    }
  }, {
    key: 'toggleLoader',
    value: function toggleLoader() {
      var wrapper = document.querySelector(this.galleryWrapper);
      wrapper.classList.toggle('loading');
    }
  }]);
  return Sliders;
}();

exports.default = Sliders;